import React from 'react'
import PropTypes from 'prop-types'
import ReactDOM from 'react-dom'
import TweenLite from 'gsap'
import BlueStore from '@leverege/data-store'
import { OverlayTrigger, Popover, Button } from 'react-bootstrap'

import style from './style.css'

export default class DeviceIndicator extends React.Component {
  
  constructor( props ) {
    super( props )
    this.ref = React.createRef()
    this.lastCount = 0
    this.lastCountUpdate = 0
    this.onStatus = this.onStatus.bind( this )
    this.onCancel = this.onCancel.bind( this )
    this.state = { status : {}, showPopover : false, lastMessageCount : 0 }
  }

  componentWillMount() {
    const { device } = this.props
    this.deviceState = device && device.accessToken && BlueStore.createAppState( device.accessToken, 'simulator' )
    if ( this.deviceState ) {
      this.deviceState.signIn().then( () => {
        if ( this.deviceState ) {
          // this.deviceState._db.on( "", function( e ) { console.log( 'received', e.val() ) }, function( e) { console.log( 'canclled', e ); } )
          // this.deviceState._access.on( "", function( e ) { console.log( 'received', e.val() ) } )
          this.deviceState.onStatus( this.onStatus, this.onCancel )
        }
      } )
    }

  }

  componentWillUnmount() {
    if ( this.deviceState ) {
      this.deviceState.offStatus( this.onStatus )
      this.deviceState = null
    }
  }

  onTogglePopover() {
    this.setState( { showPopover : !this.state.showPopover } )
  }

  onStatus( snap ) {

    const status = snap.val()
    this.setState( { status } )

    if ( status && status.detail && this.lastCount < status.detail.messageCount ) {
      this.lastCount = status.detail.messageCount
      this.lastCountUpdate = status.updated
      const el = this.ref.current
      if ( el ) {
        if ( el.style ) {
          el.style.backgroundColor = '#2ABBAF'
          el.style.opacity = 1.0
        }
        TweenLite.to( el, 1, { backgroundColor : 'transparent', overwrite : 'all' } )
      }
    }
  }

  onCancel( x ) {

  }

  render() {
    const { status } = this.state
    const messages = status && status.detail && status.detail.messageCount
    let icon = `fa fa-lg fa-lightbulb-o ${style[`status-${status && status.state}`]}`
    const popover = ( 
      <Popover title="Simulator" id={`sim-status-${this.props.device.id}`}>
        <div>
          <strong>Status:</strong> 
          {' '}
          {status && status.state}
        </div>
        <div>
          <strong>Messages Sent:</strong> 
          {' '}
          { messages }
        </div>
        <div>
          <strong>Connected:</strong> 
          {' '}
          {status && status.detail && status.detail.connected ? 'Connected' : 'Disconnected'}
          {' '}
        </div>
      </Popover>
    )

    if ( status ) {
      // TweenLite.to( s, 1, { backgroundColor : "transparent", overwrite : "all" } )

    } else {
      icon = 'fa fa-question fa-fw fa-lg'
    }
    return (
      <OverlayTrigger ref={this.ref} rootClose trigger="click" placement="bottom" overlay={popover}>
        <Button bsStyle="link" bsSize="large" className="round"><i className={icon} /></Button>
      </OverlayTrigger>
    )
  }
}
